// src/components/Events/Tree/TreeMessageDialog.jsx
import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Typography
} from '@mui/material';

export default function TreeMessageDialog({
    open,
    onClose,
    onSubmit,
    maxLength = 80,

    // ✅ 추가: 수정 모드 지원
    initialValue = '',                // 기본 입력값
    title = '트리에 남길 한마디',      // 다이얼로그 제목
    submitText = '남기기',            // 확인 버튼 문구
}) {
    const [value, setValue] = useState('');

    // ✅ open 될 때마다 initialValue로 세팅
    useEffect(() => {
        if (open) setValue((initialValue || '').slice(0, maxLength));
    }, [open, initialValue, maxLength]);

    const handleSubmit = () => {
        const trimmed = value.trim();
        if (!trimmed) return;
        onSubmit(trimmed);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    짧은 메시지를 남겨주세요 (최대 {maxLength}자)
                </Typography>

                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={2}
                    value={value}
                    onChange={(e) => setValue(e.target.value.slice(0, maxLength))}
                    placeholder="예: 산들 다락방 너무 좋아요!"
                    inputProps={{ maxLength }}
                />

                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: 'block', textAlign: 'right', mt: 0.5 }}
                >
                    {value.length}/{maxLength}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>취소</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!value.trim()}
                >
                    {submitText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}